import { downloadProcessChartAttachment } from '../../../api/processChart';
import { ProcessChart } from '../../../types/processChart';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';
import { PreviewAttachmentList } from './previewShared';

interface Props {
  detail: ProcessChart;
}

function ProcessChartPreviewView({ detail }: Props) {
  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>공정도</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label className="is-span-2">
            제목 *
            <input readOnly value={detail.title || ''} />
          </label>
          <label className="is-span-2">
            관련 제품
            <input readOnly value={detail.productName || ''} />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={3} readOnly value={detail.remark || ''} />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <h3 style={{ margin: '0 0 8px' }}>첨부파일</h3>
        <p className="quality-form__hint">도면·공정표 등을 첨부할 수 있습니다.</p>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) => {
            void downloadProcessChartAttachment(
              detail.processChartId,
              file.attachmentId,
              file.fileName
            );
          }}
        />
      </section>
    </div>
  );
}

export default ProcessChartPreviewView;
